<div class="flex__child--auto flex--column" data-test="customer">
  <router-outlet></router-outlet>
</div>
